import styled from 'styled-components';

export const PageContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 960px;
  min-height: calc(100vh / var(--scale) - 140px);
  padding: 60px;
  background: #00000085;

  section {
    margin-bottom: 30px;
    border-radius: 60px;
    display: flex;
    flex-direction: column;
    text-align: left;
    color: #fff;
  }
  p {
    font-size: 34px;
    font-weight: 400;
    line-height: 1.1;
  }
  h3 {
    font-family: 'Krungthep';
    font-size: 36px;
    color: #ffff00;
    text-transform: uppercase;
    letter-spacing: 1.5px;
  }
`;

export const InviteFriendsNote = styled.section`
  background: #d57bffbb !important;
  border: 1px solid #a4a5a2;
  padding: 30px 60px 40px;

  nav {
    display: flex;
    align-items: center;
    vertical-align: middle;
    margin-bottom: 20px;
    gap: 20px;
  }
`;

export const InviteFriendsForm = styled.section`
  background: #d57bffbb !important;
  border: 1px solid #a4a5a2;
  font-size: 34px;
  padding: 30px;

  nav {
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
    gap: 20px;

    > button {
      flex: 1;
      text-align: center;
      background: #ffff00;
      text-transform: uppercase;
      border-radius: 45px;
      height: 200px;
      border: 1px solid #a4a5a2;
      font-size: 38px;
      font-weight: 500;
      box-shadow: 5px 7px 0 0 #262626;
      font-family: 'Krungthep';
    }
    > div {
      flex: 1;
      height: 200px;
      display: flex;
      flex-direction: column;
      border-radius: 45px;
      align-items: center;
      vertical-align: center;
      text-align: center;
      justify-content: center;

      color: #c6c6c6;
      font-size: 32px;
      background: #32363c70;
      border: 1px solid #a4a5a2;

      span {
        color: #fff;
        font-size: 50px;
        font-weight: 500;
        display: flex;
        gap: 10px;
        margin-bottom: 10px;
      }
    }
  }
  #invitationLink {
    display: flex;
    padding: 20px;
    border-radius: 55px;
    gap: 10px;
    background: #32363c70;
    border: 1px solid #a4a5a2;

    input {
      color: #fff;
      border: 0;
      flex: 1;
      display: flex;
      font-size: 40px;
      height: 50px;
      background: none;
      margin-top: 20px;
      margin-left: 20px;
      margin-right: 10px;
      border-bottom: 1px solid #faff00;

      &.link {
        display: block;
      }
      &.message {
        display: none;
      }
    }
    button {
      font-size: 36px;
      border-radius: 50%;
      background: #32363c;
      height: 80px;
      width: 80px;
      border: 1px solid #ebebeb;

      img {
        height: 45px;
        margin-top: 10px;
      }
    }

    &.copied {
      border: 1px solid #faff00;

      input {
        &.link {
          display: none;
        }
        &.message {
          display: block;
          border: none;
          color: #faff00;
          margin: 0;
          height: 80px;
          /* font-size: 50px; */
          padding-left: 10px;
        }
      }

      button {
        border: 1px solid #faff00;
      }
    }
  }
`;

export const MysteryChestSubscribe = styled.section`
  background: #242424aa !important;
  border: 1px solid #d57bff;
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 370px;
  padding: 30px 40px 100px;
  margin-top: 300px;
  text-align: center;
  align-items: center;

  .box {
    width: 800px;
    margin-top: -500px;
    margin-bottom: -130px;
  }
  h3 {
    margin-top: 20px;
    font-size: 52px;
    text-align: center;
    margin-bottom: 20px;
  }
  p {
    text-align: center;
    line-height: 1.3;
  }
  .subscription {
    background: #604d6b !important;
    border: 1px solid #d57bff;
    margin: 50px 0;
    padding: 50px 40px;
    border-radius: 55px;
    text-align: left;
    position: relative;

    p {
      text-align: left;
      width: 80%;
      font-size: 42px;
    }
    img {
      width: 150px;
      position: absolute;
      top: 40px;
      right: 40px;
    }
    nav {
      display: flex;
      gap: 40px;
      margin-top: 60px;

      button {
        flex: 1;
        font-size: 36px;
        height: 150px;
        color: #000;
        border: 0;
        border-radius: 65px;
        font-family: 'Krungthep';
        text-transform: uppercase;
        line-height: 1.1;

        &.open {
          background: #b2ff82;
        }
        &.check {
          background: #faff00;
        }
      }
    }
  }
`;

export const MysteryChest = styled.section`
  background: #242424aa !important;
  border: 1px solid #d57bff;
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 370px;
  padding: 30px 60px;

  h3 {
    margin-top: 40px;
    font-size: 52px;
  }
  > div {
    width: 70%;

    .level {
      margin-top: 60px;
      color: #aaa;
      font-size: 48px;
    }
    .levelUp {
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 46px;
      gap: 10px;
      font-weight: 500;

      img {
        height: 40px;
      }
    }
    .levelOne {
      margin-top: 5px;
      color: #fff;
    }
    .levelLink {
      margin-top: 5px;
      color: #d57bff;
    }
  }
  > img {
    position: absolute;
    right: 0;
    top: -100px;
    display: flex;
    width: 500px;
  }
  .progress {
    width: 100%;
    border-radius: 10px;
    height: 20px;
    margin-top: 20px;
    margin-bottom: 30px;
    background: #aaa;
    overflow: hidden;

    span {
      display: flex;
      /* width: 70%; */
      height: 100%;
      border-radius: 10px;
      background-image: linear-gradient(90deg, #d57bff, #faff00);
    }
  }
`;

export const FriendsNote = styled.section`
  background: #242424aa !important;
  border: 1px solid #a4a5a2;
  padding: 30px;

  h3 {
    text-align: center;
    font-size: 32px;
    margin-bottom: 10px;
    font-family: Roboto, sans-serif;
  }
  p {
    text-align: center;
    font-size: 34px;
  }
  .note {
    background: #604d6b;
    color: #fff;
    display: flex;
    align-items: center;
    border-radius: 50px;
    margin-top: 30px;
    padding: 30px;
    text-align: left;
    border: 1px solid #a4a5a2;
    height: 300px;
    position: relative;

    p {
      text-align: left;
      width: 60%;

      span {
        color: #d57bffbb;
      }
      &.available {
        width: 80%;
        font-size: 46px;
      }
    }
    img {
      display: flex;
      width: 350px;
      top: -20px;
      right: 20px;
      position: absolute;
    }
  }
`;
